import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

// Listen to the theme's confirmed cart result, never to a click alone.
let toastTimer;
let focusExit;
function showCartLink() {
  const toast = document.querySelector('[data-cart-toast]');
  if (!toast) return;
  clearTimeout(toastTimer);
  if (focusExit) toast.removeEventListener('focusout', focusExit);
  toast.hidden = false;
  toast.querySelector('[data-cart-toast-status]').textContent = 'Adicionado ao carrinho';
  toastTimer = setTimeout(() => {
    // Do not remove a keyboard user's focused link. Hide it once focus leaves.
    if (toast.contains(document.activeElement)) {
      focusExit = () => { toast.hidden = true; };
      toast.addEventListener('focusout', focusExit, { once: true });
    } else toast.hidden = true;
  }, 5000);
}
document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  if (event.action !== 'add' || !event.promise) return;
  event.promise.then((result) => {
    if (result && !result.detail?.didError && !result.userErrors?.length) showCartLink();
  }).catch(() => {});
});

document.addEventListener('change', (event) => {
  const choice = event.target.closest('[data-pair-choice]');
  if (choice) choice.closest('form').querySelector('[data-pair-total]').textContent = choice.dataset.total;
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-loumi-pair]');
  if (!form) return;
  event.preventDefault();
  if (form.dataset.busy === 'true') return;
  const selected = form.querySelector('[data-pair-choice]:checked');
  const base = form.querySelector('[name="items[0][id]"]');
  if (!selected || !base) return;
  const items = [base, selected].map((input) => ({ id: Number(input.value), quantity: 1 }));
  const button = form.querySelector('[type="submit"]');
  const buttonText = form.querySelector('[data-pair-button-text]');
  const status = form.querySelector('[data-pair-status]');
  form.dataset.busy = 'true';
  form.setAttribute('aria-busy', 'true');
  button.disabled = true;
  buttonText.textContent = 'Adicionando…';
  status.textContent = '';
  const deferred = CartLinesUpdateEvent.createPromise();
  // The header and native cart receive the same event as a normal product add.
  form.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add', context: 'product',
    lines: items.map((item) => ({ merchandiseId: String(item.id), quantity: item.quantity })),
    promise: deferred.promise,
  }));
  let added = false;
  try {
    const sections = [...document.querySelectorAll('cart-items-component[data-section-id]')].map((el) => el.dataset.sectionId);
    const response = await fetch(form.getAttribute('action') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: [...new Set(sections)].slice(0, 5).join(','), sections_url: window.location.pathname }),
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || 'Não foi possível adicionar. Confira a disponibilidade e tente novamente.');
    added = true;
    const cartResponse = await fetch(form.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!cartResponse.ok) throw new Error('Não foi possível atualizar o resumo do carrinho.');
    const cart = await cartResponse.json();
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, sections: data.sections, source: 'loumi-perfect-pair', productId: form.dataset.productId, itemCount: 2, didError: false },
    });
    status.textContent = 'Sua combinação foi adicionada ao carrinho.';
  } catch (error) {
    deferred.reject(error);
    status.textContent = added
      ? 'As velas foram adicionadas. Abra o carrinho para conferir antes de adicionar novamente.'
      : (error instanceof TypeError ? 'Não foi possível confirmar a adição. Confira sua conexão e o carrinho antes de tentar novamente.' : error.message || 'Não foi possível adicionar. Tente novamente.');
    const link = document.createElement('a');
    link.href = form.dataset.cartUrl;
    link.textContent = ' Ver carrinho';
    status.append(link);
  } finally {
    form.dataset.busy = 'false';
    form.removeAttribute('aria-busy');
    button.disabled = false;
    buttonText.textContent = 'Adicionar as duas';
  }
});
